// MEN-4915: import the `/pure` entry, not the default one. The default
// `@stripe/stripe-js` entry injects https://js.stripe.com at MODULE SCOPE:
//
//   var stripePromise = Promise.resolve().then(function () { return loadScript(null); });
//
// `src/utils/index.ts` re-exports this module and 118 files import that barrel
// (main.tsx among them), so that injection ran on every page load of every
// route. In production that made Stripe.js the heaviest third party -- 435
// requests / 155MB over two days -- on routes that take no payment: /signin,
// /coach/schedule, /sessions/past, /m/insights.
//
// The `/pure` entry defers injection until loadStripe() is actually called,
// which happens only in the membership checkout flow
// (components/GetStarted/MembershipSelect/Prices/Card.tsx).
import { loadStripe } from '@stripe/stripe-js/pure';

import type { Stripe } from '@stripe/stripe-js';

let stripePromise: Promise<Stripe | null> | null = null;

export const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);
  }
  return stripePromise;
};
